import { useRouteError } from 'react-router-dom';
import axios from 'axios';
import { AppBar, Toolbar } from '@mui/material';
import AppHeaderLeftContainer from '../../application/header/LeftHeader';
import AppContent from '../../application/container/Container';
import AppFooter from '../../application/footer/Footer';
import UserConfigError from './iam/UserInfoError';
import RefreshTokenError from './iam/RefreshTokenError';
import DefaultFallbackComponent from './DefaultError';
import ErrorAxiosComponent from './AxiosError';

const ErrorThrowedComponents = {
  GET_USER_INFO_ERROR: UserConfigError,
  REFRESH_TOKEN_ERROR: RefreshTokenError,
};

type ErrorMessage = keyof typeof ErrorThrowedComponents;

function checkErrorMessageType(errorMessage: unknown): errorMessage is ErrorMessage {
  return errorMessage === 'GET_USER_INFO_ERROR' || errorMessage === 'REFRESH_TOKEN_ERROR';
}

const ErrorMain = () => {
  const error = useRouteError();
  let ErrorComponent = DefaultFallbackComponent;

  if (error instanceof Error && checkErrorMessageType(error.message)) {
    ErrorComponent = ErrorThrowedComponents[error.message];
  } else if (axios.isAxiosError(error)) {
    ErrorComponent = ErrorAxiosComponent;
  }

  return (
    <div data-testid="error-page">
      <AppBar position="static" sx={{ backgroundColor: '#063142' }} data-testid="error-header">
        <Toolbar>
          <AppHeaderLeftContainer />
          <div className="flex flex-nowrap flex-auto" />
        </Toolbar>
      </AppBar>
      <AppContent data-testid="error-content">
        <ErrorComponent />
      </AppContent>
      <AppFooter data-testid="error-footer" />
    </div>
  );
};

export default ErrorMain;
